import script from "./BaseLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLayout.vue?vue&type=script&setup=true&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=08b0f9a2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b0f9a2"]])

export default __exports__